import { useState, useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import AppProviders from './AppProviders'
import AppRouter from './AppRouter'
import './App.css'

/*  Main app component, activates providers for the whole app (Theme, Snackbar, Apollo and AuthContext) */
const App = () => {
    return (
        <Router style={{ height: '100vh' }}>
            <AppProviders>
                <AppRouter />
            </AppProviders>
        </Router>
    )
}

export default App
